import { useLazyQuery } from '@apollo/client';
import { message } from 'antd';
import { GENERATE_PICKUP_APPOINTMENT_DOWNLOAD_REPORT } from '../graphql/queries/generatePickupAppointmentDownloadReport';
import { PickupAppointmentFiltersType } from '../graphql/queries/getPickupAppointmentListing';

interface GeneratePickupAppointmentReportResponse {
    generatePickupAppointmentDownloadReport?: string;
}

export interface PickupAppointmentDownloadFilters extends PickupAppointmentFiltersType {
    warehouseId: number;
}

export function buildPickupAppointmentDownloadFilters(
    filters: Omit<PickupAppointmentFiltersType, 'warehouseId'>,
    warehouseId?: string | number | null
): PickupAppointmentDownloadFilters {
    return {
        ...filters,
        warehouseId: Number(warehouseId),
    };
}

export function useGeneratePickupAppointmentReport() {
    const [generateReport, { loading }] = useLazyQuery<GeneratePickupAppointmentReportResponse>(
        GENERATE_PICKUP_APPOINTMENT_DOWNLOAD_REPORT,
        {
            fetchPolicy: 'network-only',
        }
    );

    const submit = async (filters: PickupAppointmentDownloadFilters, timezone?: string | null) => {
        try {
            const { data } = await generateReport({
                variables: {
                    filters,
                    timezone,
                },
            });
            const fileName = data?.generatePickupAppointmentDownloadReport;
            if (!fileName) {
                message.error('Failed to start report generation task');
                return null;
            }
            return fileName;
        } catch (error: any) {
            message.error(error?.message || 'Failed to start report generation task');
            return null;
        }
    };

    return {
        submit,
        loading,
    };
}
